// ===== Interfaces =====

import { IShouldPlayPreviewAudioEndPromptArgs } from '../interfaces';

/**
 * Only reader preview dictation notes should append the spoken unlock or
 * purchase reminder after the truncated audio finishes.
 */
export default function shouldPlayPreviewAudioEndPrompt(
    data: IShouldPlayPreviewAudioEndPromptArgs,
): boolean {
    const {
        readOnly,
        readOnlyUsesPreviewSource,
        isPostContentDictation,
        previewAudioEndPromptText,
    } = data;

    if (!readOnly) {
        return false;
    }

    if (!readOnlyUsesPreviewSource) {
        return false;
    }

    if (!isPostContentDictation) {
        return false;
    }

    return String(previewAudioEndPromptText || '').trim().length > 0;
}
